import { useMemo } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Result = Readonly<{
	trackClickLink: () => void;
}>;

export function useDescriptionTracking(): Result {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();

	return useMemo(
		() => ({
			trackClickLink: () => {
				const numberId = parseInt(id, 10);
				void track('petition_description_link_clicked', {
					petition_id: Number.isNaN(numberId) ? undefined : numberId,
				});
			},
		}),
		[track, id],
	);
}
